interface Size {
    id: string;
    size: string;
    title?: string; 
    label?: string;
}

interface Product {
    id: string;
    title: string;
    productType: string;
    size: Size[];
    finish?: string;
    label?: string;
    envelopeOptions?: string;
    hasEnvelope?: boolean;
    paper?: string;
    envelope?: any;
    nonEnvelope?: any;
    ink?: string;
    windowed?: boolean; // optional property
}


export const Products: Product[] = [
    {
        id: "9",
        title: "Bi-Fold Self-Mailers",
        productType: "Bi-Fold Self-Mailers",
        hasEnvelope: false,
        paper: '80# text',
        finish: 'Glass Coated',
        size: [
            {
                id: "9",
                size: "6x18"
            }
        ],
    },
    {
        id: "5",
        title: "Personal Letters",
        productType: "Personal Letters",
        hasEnvelope: true,
        paper: '60# Statement',
        finish: 'Uncoated',
        label: "5.5x8.5",
        envelopeOptions: '4 Options',
        envelope: 'A6 White / A6 Grey Herringbone',
        ink: 'Full color or black & white',
        size: [
            {
                id: "5",
                size: "8.5x5.5",
                label: "5.5x8.5"
            }
        ]
    },
    {
        id: "13",
        title: "Postcards",
        productType: "Postcards",
        hasEnvelope: false,
        paper: '100#-120# Cover',
        finish:'Glossy Front/Uncoated Back', 
        size: [
            {
                id: "13",
                size: "4x6",
                label: "4x6"
            },
            {
                id: "14",
                size: "6x9",
                label: "6x9"
            },
            {
                id: "15",
                size: "6x11",
                label: "6x11"
            },
            {
                id: "21",
                size: "12x9",
                label: "9x12"
            }
        ]
    },
    {
        id: "16",
        title: "Real Penned Letter",
        productType: "Real Penned Letter",
        hasEnvelope: true,
        paper: '60# Statement',
        finish: 'Uncoated',
        envelopeOptions: '5 Options',
        envelope: 'A6 Lavender / A6 Navy Blue',
        ink: 'Blue or black ink options',
        size: [
            {
                id: "16",
                size: "8.5x5.5",
                title: "Personal Letter",
                label: "5.5x8.5",
            },
            {
                id: "38",
                size: "11x8.5",
                title: "Professional Letter",
                label: "8.5x11"
            }
        ]
    },
    {
        id: "11",
        title: "Tri-Fold Self-Mailers",
        productType: "Tri-Fold Self-Mailers",
        hasEnvelope: false,
        paper: '80# text',
        finish: 'Glass Coated',
        size: [
            {
                id: "11",
                size: "12x9",
                label: "8.5x11"
            }
        ]
    },
    {
        id: "2",
        title: "Professional Letters - Windowed Envelope",
        productType: "Professional Letters",
        hasEnvelope: true,
        paper: '60# Statement',
        envelope: '#10 Double-Window',
        nonEnvelope: '#10 Grey',
        envelopeOptions: '1 Option',
        finish: 'Uncoated',
        label: "8.5x11",
        ink: 'Full color or black & white',
        size: [
            {
                id: "2",
                size: "11x8.5",
                label: "8.5x11",
            }
        ],
        windowed: true
    },
    {
        id: "4",
        title: "Professional Letters - Non-windowed Envelope",
        productType: "Professional Letters",
        hasEnvelope: true,
        paper: '60# Statement',
        envelopeOptions: '5 Options',
        finish: 'Uncoated',
        label: "8.5x11",
        envelope: '#10 Grey',
        ink: '',
        size: [
            {
                id: "4",
                size: "11x8.5",
                label: "8.5x11",
            }
        ],
        windowed: false
    },
    {
        id: "18",
        title: "Snap Pack Mailers",
        productType: "Snap Pack Mailers",
        hasEnvelope: false,
        paper: '28# bond',
        finish: 'Uncoated',
        label: "8.5x11",
        size: [
            {
                id: "18",
                size: "11x8.5",
                label: "8.5x11"
            }
        ]
    }
];